import StepId from "@/model/progress/StepId"
import { providerState, sessionState } from "@/state"

const providerKey = "proceed_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "proceedResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: () => {
                let applyResponse = providerState.getApplyResponse(sessionState.providerKey)
                if (
                    applyResponse?.pendingReasons?.length &&
                    applyResponse?.pendingReasons?.includes("additional_documents_needed")
                ) {
                    return `/providers/${providerKey}/terms`
                }

                return `/providers/${providerKey}/paymentPlans`
            },
        },
        {
            name: "proceedPrequalifyStart",
            path: `/providers/${providerKey}/modes/prequalify/start`,
            redirect: `/providers/${providerKey}/prequalifyAgreeNext`,
        },
        {
            name: "proceedPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/checkCalifornia`,
        },
        {
            name: "proceedPrequalifyTerms",
            path: `/providers/${providerKey}/terms`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/proceed/ProceedIframeView.vue"),
        },
        {
            name: "proceedApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.COMPLETE },
            extends: "approved",
            component: () => import("@/views/provider/proceed/ProceedCompleteView.vue"),
        },
        {
            name: "proceedPending",
            path: `/providers/${providerKey}/pending`,
            meta: { step: StepId.COMPLETE, stepper: true },
            extends: "pending",
            component: () => import("@/views/provider/proceed/ProceedCompleteView.vue"),
        },
        {
            //TODO change redirect to work with /prequalified
            name: "proceedResumeFromPaymentPlanReview",
            path: `/providers/${providerKey}/resume/from-payment-plan-review`,
            redirect: `/providers/${providerKey}/paymentPlans`,
            //need to redirect back to plans because of offer_slugs(plan id) updating
        },
    ],
}
